module.exports = __webpack_public_path__ + "media/images/icons/outlined/menu-fold-07dee8067373e5b2cf77626392912a26.svg";